import { createSlice } from "@reduxjs/toolkit";

interface AdInitialStateModel {
  adType:"realState"|"vehicle"|null,
 adData:any
 doneSteps:number[],
 selectedPackages:any;
}
const initialState: AdInitialStateModel = {
 adData:null,
 adType:null,
 doneSteps:[],
 selectedPackages:null
};

const adManagementSlice = createSlice({
  name: "accountSlice ",
  initialState: initialState,
  reducers: {
    handleSetAdData: (state, action) => {
      state.adData = action.payload.data;
    },
    handleSetAdType: (state, action) => {
      state.adType = action.payload.type;
    },
    handleSetDoneSteps: (state, action) => {
      state.doneSteps= action.payload.data;
    },
    handleSelectedPackageDoping: (state, action) => {
      state.selectedPackages= action.payload.data;
    },
    handleResetAllAdvertState: (state) => {
      Object.assign(state, initialState);
    },
    
   
    
  },
});

export const {
  handleSetAdData,
  handleSetAdType,
  handleSetDoneSteps,
  handleSelectedPackageDoping,
  handleResetAllAdvertState
} = adManagementSlice.actions;
export default adManagementSlice ;
